import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA, } from '@angular/material/dialog';
import { NgForm } from '@angular/forms';

import { AlertDialogComponent } from '../alert-dialog/alert-dialog.component';
import { ConfirmationDialog } from '../confirmation-dialog/confirmation-dialog.component';
import { MantenedorUsuariosService } from 'src/app/services/mantenedor-usuarios/mantenedor-usuarios.service';

export interface DialogData 
{
    usuario: any
    estadoCivil: any
    prevision:any
    sistemaSalud: any
    regiones: any
    regionesDirDat: any
    sexos: any
    comunas: any
    comunasDirDat: any
    roles: any
    recarga: boolean
    tipoAfiliado: any
    fechaNacimiento: any
    fechaAfiliado: any
    rolUsuario:string
    rolSeleccionado: any
}
declare const Rut: any;
@Component({
    selector: 'dialog-overview-example-dialog',
    templateUrl: '../../pages/mantenedor-usuarios/edita-usuario.component.html',
    styleUrls: ['../../pages/mantenedor-usuarios/mantenedor-usuarios.component.css']
})
export class DialogEditaUsuario implements OnInit
{     
    usuario: any = 
    { 
        id: this.data.usuario.id, nombres:this.data.usuario.nombres, apellidoPaterno: this.data.usuario.apellidoPaterno, 
        apellidoMaterno: this.data.usuario.apellidoMaterno, correo: this.data.usuario.mail,
        rut: this.data.usuario.rut + '-' + this.data.usuario.dv, tipoAfiliado: this.data.usuario.tipoAfiliado, 
        estadoAfiliado: this.data.usuario.estado, sexo: this.data.usuario.idSexo, 
        estadoCivil: this.data.usuario.idEstadoCivil, fechaIngreso: this.data.fechaAfiliado, 
        prevision: this.data.usuario.idPrevision,
        sistemaSalud: this.data.usuario.idsistemaSalud,
        fechaNacimiento: this.data.fechaNacimiento, fonoFijo: this.data.usuario.telefonoFijo, 
        fonoMovil: this.data.usuario.telefonoMovil,
        rol: [
        { 
            id: this.data.usuario.roles.length > 0? this.data.usuario.roles.id : null, 
            idUsuarioRol: this.data.usuario.roles.length > 0? this.data.usuario.roles.idUsuarioRol : null,
        }], 
        direccion: 
        { 
            id: this.data.usuario.direccion.id, descripcion: this.data.usuario.direccion.descripcion, comuna: this.data.usuario.direccion.idComuna, 
            region: this.data.usuario.direccion.idRegion, numero: this.data.usuario.direccion.numero, 
            descripcionAdicional: this.data.usuario.direccion.descripcionAdicional 
        }, 
        datosLaborales: 
        { 
            id: this.data.usuario.datosLaborales.id, tipoUnidad: this.data.usuario.datosLaborales.tipoUnidad, unidad: this.data.usuario.datosLaborales.unidad, 
            calidadJuridica: this.data.usuario.datosLaborales.calidadJuridica, estamento: this.data.usuario.datosLaborales.estamento, 
            direccion: 
            { 
                id: this.data.usuario.datosLaborales.direccion.id, 
                descripcion: this.data.usuario.datosLaborales.direccion.descripcion, 
                comuna: this.data.usuario.datosLaborales.direccion.idComuna, 
                region: this.data.usuario.datosLaborales.direccion.idRegion, 
                numero: this.data.usuario.datosLaborales.direccion.numero, 
                descripcionAdicional: this.data.usuario.datosLaborales.direccion.descripcionAdicional
            } 
        }
    }
  
    constructor( public dialogRef: MatDialogRef<DialogEditaUsuario>, private dialog: MatDialog, 
                 @Inject(MAT_DIALOG_DATA) public data: DialogData, private mantenedorService: MantenedorUsuariosService) 
    { 
        this.data.recarga = false 
        this.data.rolUsuario = localStorage.getItem('rol')
        this.data.tipoAfiliado = ['ACTIVO', 'PASIVO']
    }

    

    ngOnInit(): void {     
        var seleccionados = [];    
        this.data.usuario.roles.forEach(rol =>{seleccionados.push(rol.id);})
        this.data.rolSeleccionado=seleccionados;
    }
   
    
    traeComunas()
    {
        let vm = this

        this.data.comunas = []

        this.mantenedorService.traeComunas(this.usuario.direccion.region).then( comunas => vm.data.comunas = comunas )
    }

    traeComunasDirDat()
    {
        let vm = this
        
        this.data.comunasDirDat = []

        this.mantenedorService.traeComunas(this.usuario.datosLaborales.direccion.region)
        .then( comunas => vm.data.comunasDirDat = comunas )
    }

    editarUsuario(): void 
    {
        let vm = this
        let fn = new Date(this.usuario.fechaNacimiento);   
        //let fi = new Date(this.usuario.fechaIngreso);
        let fi = new Date();
        if(this.usuario.fechaIngreso){
            let fi = new Date(this.usuario.fechaIngreso);
        }        
        if((this.usuario.fechaIngreso) && fn.getTime() > fi.getTime()){   
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger');        
        }

        //if(fn.getTime() < fi.getTime()){      
            if(Rut( this.usuario.rut)){    
                this.usuario.rol = []
                this.data.rolSeleccionado.forEach( (element: any, i: number) =>{
                    this.usuario.rol.push( { id:element, idUsuarioRol:element } ) 
                }) 
                
                let fechaNacimiento = this.usuario.fechaNacimiento.split('-')[2] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[1] + '-' + 
                                    this.usuario.fechaNacimiento.split('-')[0]

                let fechaIngreso =null
                if(this.usuario.fechaIngreso){                        
                    let fechaIngreso = this.usuario.fechaIngreso.split('-')[2] + '-' + 
                                    this.usuario.fechaIngreso.split('-')[1] + '-' + 
                                    this.usuario.fechaIngreso.split('-')[0]
                }
                this.usuario.fechaNacimiento = fechaNacimiento, this.usuario.fechaIngreso = fechaIngreso
                

                this.mantenedorService.editarUsuario(this.usuario).then
                (
                    () => 
                    {
                        vm.openAlertDialog('Se ha editado correctamente el usuario.', 'btn-success')
                        
                        vm.data.recarga = true
                        vm.dialogRef.close() 
                    }
                )
                .catch ( error => 
                {
                    console.log(error)   

                    vm.openAlertDialog('Ha ocurrido un error al editar el usuario', 'btn-danger') 
                    
                    vm.dialogRef.close() 
                })
            }else{
                this.openAlertDialog('El RUT del usuario es incorrecto. Favor Revisar', 'btn-danger') 
            }
       /* }else{
            this.openAlertDialog('La fecha de nacimiento debe ser menor a la fecha de ingreso', 'btn-danger') 
        }*/
    }

    onCancelarClick(): void { this.dialogRef.close() }  
    
    openAlertDialog(mensaje: string, clase: string)  
    {
        this.dialog.open(AlertDialogComponent, {
            data: { message: mensaje, clase: clase, buttonText: { cancel: 'Listo!' }, }
        })
    }
}